import { useFormState } from 'react-final-form'

import Button from 'common/components/button'

type Props = {
  isLoading: boolean
  children: React.ReactNode
  'data-testid': string
}

const SubmitButton = ({
  isLoading,
  children,
  'data-testid': dataTestId,
}: Props) => {
  const { hasValidationErrors, pristine, values } = useFormState()

  const examples = values.examples || []

  const hasAtLeastOneExample = examples?.some((value) => value)

  const hasAtLeastOneEmptyExample =
    examples.length > 0 &&
    examples.some((value) => {
      return value && (!value.exampleInput || !value.exampleOutput)
    })

  return (
    <Button
      type="submit"
      variant="primary"
      className="mr-6"
      data-testid={dataTestId}
      loading={isLoading}
      disabled={
        hasValidationErrors ||
        pristine ||
        isLoading ||
        !hasAtLeastOneExample ||
        hasAtLeastOneEmptyExample
      }
    >
      {children}
    </Button>
  )
}

export default SubmitButton
